/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { request as __request } from '@openapi/request';

export class ProductionBonusSetupService {

    /**
     * @param oid
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static async importProductionBonusReportData(
        oid: string,
        requestBody: any,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/production-bonus-setup/import-csv/${oid}`,
            formData: requestBody,
        });
        return result.body;
    }

}